import * as _ from 'lodash';
import { WorkItemBase } from './workitem-base-model';
import { BoldItem } from '../interfaces/workitem-bold.interface';

export abstract class WorkItemBold extends WorkItemBase implements BoldItem {
  // TODO: should be private and not accessible from all around the code
  public Answered: string;
  public FolderID: string;
  public FolderName: string;
  public DepartmentID: string;
  public DepartmentName: string;
  public OperatorID: string;
  public departmentFolder: string;
  public ACDAssignmentExpires: string;

  public Assigned: string;
  public Ended: string;
  public Flagged: string;

  constructor(workItem) {
    super(workItem);

    if (workItem) {
      this.decorateWithDefaultValues(workItem);
    }

    this._isCollapsible = true;
    this.isClosable = true;
  }

  get isEnded(): boolean {
    return this.Ended !== null;
  }

  decorateWithDefaultValues(values) {
    // TODO: use a private property for the model and create getters to this private model
    _.assign(this, values);
  }
}
